module.exports = __webpack_public_path__ + "static/media/maroon.db4d5e84.PNG";